import { Tab as MuiTab } from "@mui/material";
import { TabList as MuiTabList } from "@mui/lab";
import { Tab } from "../types";

export type TabListTab = Pick<Tab, "id" | "title" | "disabled">;

interface TabListProps {
  tabs: TabListTab[];
  onChange: (tabId: string) => void;
}

const TabList = ({ tabs, onChange }: TabListProps) => {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  return (
    <MuiTabList
      onChange={handleChange}
      sx={{ minHeight: 36 }}>
      {tabs.map((tab) => (
        <MuiTab
          key={tab.id}
          label={tab.title}
          value={tab.id}
          disableRipple
          disabled={tab.disabled}
          sx={{ minHeight: 36, py: 0.5 }}
        />
      ))}
    </MuiTabList>
  );
};

export default TabList;
